import { render, staticRenderFns } from "./ImapSettings.vue?vue&type=template&id=bc3c8708&scoped=true&"
import script from "./ImapSettings.vue?vue&type=script&lang=js&"
export * from "./ImapSettings.vue?vue&type=script&lang=js&"
import style0 from "./ImapSettings.vue?vue&type=style&index=0&id=bc3c8708&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3c8708",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc3c8708')) {
      api.createRecord('bc3c8708', component.options)
    } else {
      api.reload('bc3c8708', component.options)
    }
    module.hot.accept("./ImapSettings.vue?vue&type=template&id=bc3c8708&scoped=true&", function () {
      api.rerender('bc3c8708', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/inbox/ImapSettings.vue"
export default component.exports